export default __webpack_public_path__ + "static/media/logo-dark.86e706a8.svg";